import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlaySoundsService {
  appMusic: HTMLAudioElement;
  src: string;
  responseSound: HTMLAudioElement;
  volume: number;

  musicOff: boolean;
  soundsOff: boolean;
  musicSrc: string

  constructor() {
    this.volume = 10/100;
    this.appMusic = new Audio();
    this.appMusic.volume = this.volume;
    this.appMusic.loop = true;

    this.musicOff = true;
    this.soundsOff = true;

    this.responseSound = new Audio();
    this.responseSound.volume = this.volume;
  }

  private setSrc(source: string) {
    if(source !== this.musicSrc) {
      switch(source) {
        case 'welcome':
        case 'settings':
          this.appMusic.src = 'assets/app-branding/sounds/welcome-settings.mp3';
          break;
  
        case 'final-score':
          this.appMusic.src = 'assets/app-branding/sounds/final-score.mp3';
          break;
  
        case 'question-screen':
          this.appMusic.src = 'assets/app-branding/sounds/question.mp3';
          break;
      }
    }
  }

  public playMusic(source: string) {
    this.setSrc(source);

    this.musicSrc = source;
    // TODO: Add loop
    this.musicOff = false;
    this.appMusic.play();
  }

  public pauseMusic() {
    this.musicOff = true;
    this.appMusic.pause();
  }

  public playSound(type: string) {
    if(this.soundsOff) return;

    switch(type) {
      case 'pop-up':
      case 'rule-slide':
      case 'page-transition':
        this.responseSound.src = 'assets/app-branding/sounds/transition.mp3';
        break;

      case 'correct-answer':
        this.responseSound.src = 'assets/app-branding/sounds/correct-answer.mp3';
        break;

      case 'wrong-answer':
        this.responseSound.src = 'assets/app-branding/sounds/wrong-answer.mp3';
        break;

      case 'countdown-timer':
        this.responseSound.src = 'assets/app-branding/sounds/countdown.mp3';
        break;

      case 'primary-button':
        this.responseSound.src = 'assets/app-branding/sounds/button-action.mp3';
        break;

      case 'wheel-spin':
        this.responseSound.src = 'assets/app-branding/sounds/wheel-spin.mp3';
        break;

      case 'points-added':
      case 'points-removed':
        this.responseSound.src = 'assets/app-branding/sounds/points.mp3';
        break;

      case 'lobby-wait':
        this.responseSound.src = 'assets/app-branding/sounds/lobby-wait.mp3';
        break;

      case 'token-50':
        this.responseSound.src = 'assets/app-branding/sounds/token-50.mp3';
        break;

      case 'token-skip':
        this.responseSound.src = 'assets/app-branding/sounds/token-skip.mp3';
        break;
    }

    this.responseSound.play();
  }

  public stopSound() {
    if(this.responseSound) {
      this.responseSound.pause();
    }
  }
}
